angular.module("avant.filters").filter "OptionValueToString", ->
  (input, key) ->
    newInput = []
    angular.forEach input, ((obj, i) ->
      obj[key] = String(obj[key]) if obj and obj[key]
      @push obj
    ), newInput
    newInput